// @flow
import React from 'react';
import classNames from 'classnames';
import ReplacementDialogContainer from '../../containers/ReplacementDialogContainer/ReplacementDialogContainer';
import './ReplacementFormInput.css';
import _ from 'lodash/fp';

export type Props = {
  input: any,
  label: string,
  meta: any,
  toggleReplacementDialog: Function,
};

const ReplacementFormInput = ({input, label, meta: {touched, error}, toggleReplacementDialog}: Props) => {
  const hasReplacement = input.value && input.value.productId && input.value.variantId;
  const replacementProductUrl = `/products/${input.value.productId}`;
  return (
    <div className="ReplacementFormInput">
      <label className={classNames({'is-invalid-label': touched && error})}>
        {label}
      </label>
      <div className="row no-row-margins">
        <button
          onClick={() => toggleReplacementDialog(true)}
          type="button"
          title={`${input.value.productName} - ${input.value.variantName}`}
          className={classNames({
            'button column replacement': true,
            'warning': hasReplacement,
            'secondary hollow': !hasReplacement,
          })}>
          {hasReplacement &&
            <span>{input.value.productName} - {input.value.variantName}</span>
          }
          {!hasReplacement &&
            <span>Ingen ersättnigsprodukt</span>
          }
        </button>
        <button
          onClick={() => toggleReplacementDialog(true)}
          type="button"
          title="Redigera"
          className="button column shrink">
          <i className="fa fa-pencil"></i>
        </button>
        {hasReplacement &&
          <button
            onClick={() => input.onChange(null)}
            type="button"
            title="Ta bort"
            className="button column shrink">
            <i className="fa fa-trash"></i>
          </button>
        }
        {hasReplacement &&
          <button
            onClick={() => window.location.assign(replacementProductUrl)}
            type="button"
            title="Gå till ersättnigsprodukt"
            className="button column shrink">
            <i className="fa fa-folder-open-o"></i>
          </button>
        }
        <ReplacementDialogContainer
          replacement={!_.isEmpty(input.value) ? input.value : null}
          setReplacement={replacement => input.onChange(replacement)} />
        {touched && error &&
          <span className="form-error is-visible">{error}</span>
        }
      </div>
    </div>
  );
};

export default ReplacementFormInput;



// WEBPACK FOOTER //
// ./src/components/ReplacementFormInput/ReplacementFormInput.js